export default {"src":"/_next/static/media/cardano.3e1525dc.svg","height":14,"width":14};